import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import StorySection from "../../components/StorySection/StorySection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import PartnerSection from "../../components/PartnerSection";

const StoryPage1: React.FC = () => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="Our Story" pagesub="Story" />
      <StorySection stClass="style-2" />
      <PartnerSection pClass="section-padding pt-0" />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default StoryPage1;
